'use strict';

import React from 'react'

import PageWrapper from '@Layout/PageWrapper'
import Layout      from '@Layout/BackOffice'

import NewPaymentForm from '@/Form/NewPaymentForm'

import Link from '@Pure/Link'

export default PageWrapper(function NewPaymentPage (props)
{
	return (
		<Layout page_title="Nouveau règlement" history={ props.history }>

			<div className="page-content">

				<div className="u-flex u-content-end u-margin-bottom-20">
					<Link href="/gestion-des-reglements"
						className="c-btn u-no-margin-top">
						Retour aux règlements
					</Link>
				</div>

				<NewPaymentForm />

			</div>

		</Layout>
	);
});